  export const bot_id_display_map = {
    'mt5': 'MT5',
    'sk_prod_8KQf4duvIGvrecbp44Zduk31IXwiLSes': 'Maxence'
  }

  export const removeExchangeFromTicker = (ticker) => ticker ? ticker.replace(/.(NASDAQ|NYS|AMEX|US)/, '').replaceAll('/', '_') : ticker;

    export const doc_types_display_map = {
    'idDocs': 'Documents Sumsub',
    'passport_pictures': 'Passeport',
    'utility_bill_pictures': 'Justificatif de domicile',
    'ibans_pictures': 'Ibans',
    'agreements': 'Agreements',
    'kbis_pictures': 'Kbis',
    'company_status_pictures': 'Statuts',
    'company_report_pictures': 'Bilan',
    'company_other_pictures': 'Autres',
  }